import { Link } from "react-router-dom";

export const LogoMark = ({ size = 40, dark = false }) => (
  <img
    src={dark ? "/images/logo-stomach-light.png" : "/images/logo-stomach.png"}
    width={size}
    height={size}
    alt=""
    aria-hidden="true"
    data-testid="logo-mark"
    className="shrink-0"
  />
);

export const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="brand-logo-link"
    className="flex items-center gap-3 group"
    aria-label="Dr Dixit, Varanasi — home"
  >
    <LogoMark size={40} dark={dark} />
    <span className="leading-none">
      <span
        className={`block font-heading font-bold text-lg tracking-tight ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        Dr Dixit, <span className="text-sky-600">Varanasi</span>
      </span>
      <span
        className={`block text-[11px] font-medium tracking-[0.18em] uppercase mt-1 ${
          dark ? "text-sky-300" : "text-sky-600"
        }`}
      >
        DM (Gastro) IMS BHU
      </span>
    </span>
  </Link>
);
